// Гарын үсэг зурах талбар (хуруу, хулгана, үзэг — pointer events). onChange(dataUrl | null) — PNG base64, хоосон бол null.
// Канвасыг дэлгэцийн нягтралаар зурна; илгээхдээ 2x хүртэл бууруулж (файлын хэмжээ бага) хадгална.
import React, { useEffect, useRef, useState } from "react";

export default function SignaturePad({ onChange, height = 150 }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = ref.current;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const w = c.clientWidth;
    c.width = w * dpr;
    c.height = height * dpr;
    const ctx = c.getContext("2d");
    ctx.scale(dpr, dpr);
    ctx.lineWidth = 2.4;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#1c1c1c";
  }, [height]);

  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };
  const down = (e) => {
    e.preventDefault();
    ref.current.setPointerCapture(e.pointerId);
    drawing.current = true;
    last.current = pos(e);
    const ctx = ref.current.getContext("2d");
    ctx.beginPath();
    ctx.arc(last.current.x, last.current.y, 1.2, 0, Math.PI * 2);
    ctx.fillStyle = "#1c1c1c";
    ctx.fill();
  };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const p = pos(e);
    const ctx = ref.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(last.current.x, last.current.y);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    last.current = p;
  };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    setEmpty(false);
    onChange(ref.current.toDataURL("image/png"));
  };
  const clear = () => {
    const c = ref.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setEmpty(true);
    onChange(null);
  };

  return (
    <div className="flex flex-col gap-1">
      <div className="relative rounded-xl border-2 border-dashed border-[#d9c8ef] bg-white overflow-hidden">
        <canvas ref={ref} style={{ width: "100%", height, touchAction: "none", display: "block", cursor: "crosshair" }}
          onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerCancel={up} onPointerLeave={up} aria-label="Гарын үсэг зурах талбар" />
        {empty && <span className="pointer-events-none absolute inset-0 flex items-center justify-center text-[13px] text-[#b8a9cf]">Энд хуруугаараа гарын үсгээ зурна уу</span>}
        <span className="pointer-events-none absolute left-4 right-4 bottom-8 border-b border-[#ece4f7]" />
      </div>
      {!empty && <button type="button" onClick={clear} className="self-end text-[12px] text-[#6e5e8a] bg-transparent border-0 cursor-pointer">Арилгах</button>}
    </div>
  );
}
